module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.8fed7e00.png";